import React, { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { AuthContext } from "@app/providers";
import { Input, Password, Button, LoginLayout, Toast } from "@app/components";
import { emailPattern, useLocation } from "@app/utils";
import { getDefaultUrl } from "@app/routes/route-helpers";
import { logInUser } from "@app/services";
import { FormFlexWrapper, FlexWrapper } from "@app/components/commonStyles";
import { ButtonContainer, SignInContainer } from "./signIn-component";
import { logoutUser } from "@app/services";

export default function EducatorSignin() {
  const { register, handleSubmit, errors } = useForm();
  const { setUserInfo } = useContext(AuthContext);
  const { navigate } = useLocation();
  const [buttonText, setButtonText] = useState<string>("Sign In");
  const [showToast, setShowToast] = React.useState(false);
  const [toastMessage, setToastMessage] = useState<any>({
    type: "",
    message: "",
  });

  async function onSubmit(data: any) {
    setButtonText("Signing In...");
    const params: any = {};
    Object.assign(params, {
      email: data.email,
      password: data.password,
      userType: "educator",
    });

    logInUser(params)
      .then((response: any) => {
        setButtonText("Sign In");
        if (response._responseStatus === 1) {
          if (response.userJson['ageVerfiedflag'] == 'f' && response.userJson['educatorApprovedFlag'] == 'false') {
            logoutUser(params).then((res: any) => {
              localStorage.clear();
              setUserInfo(null);
              navigate("/sign-in/educator");
            })
          }
          localStorage.setItem("userData", JSON.stringify(response));
          localStorage.setItem("parentDataSource", JSON.stringify(response));
          localStorage.setItem("first", response.userJson.firstName)
          localStorage.setItem("last", response.userJson.lastName)
          setUserInfo(response);
          const defaultUrl: string = getDefaultUrl(response.userJson);
          // navigate("/create-avatar")
          navigate(defaultUrl);
        } else {
          setShowToast(true);
          setToastMessage({
            type: "error",
            message: response.msg,
          });
        }
      })
      .catch((e: any) => {
        console.log(e, "LoginError");
        setButtonText("Sign In");
        setShowToast(true);
        setToastMessage({
          type: "error",
          message: `Something went wrong, Please try again`,
        });
      });
  }

  function onChange(data: any) { }

  function navigateTo() {
    navigate("/sign-in");
  }

  return (
    <LoginLayout path="" label="">
      <Toast
        message={toastMessage.message}
        showToast={showToast}
        type={toastMessage.type}
        title="Sign In Failed"
        onClose={() => setShowToast(false)}
      />
      <SignInContainer>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="w-100"
          onChange={onChange}
        >
          <h3 className="primary-header text-center mb-3">
            Educator Account Sign In
          </h3>
          <FormFlexWrapper className="mb-0">
            <div className="child only-child">
              <Input
                hideLabel={false}
                label="Email Address"
                type="email"
                placeholder="Email Address"
                name="email"
                register={register({
                  required: true,
                  pattern: emailPattern,
                })}
                error={
                  (errors.email &&
                    errors.email.type === "required" &&
                    "Please enter Email Address") ||
                  (errors.email &&
                    errors.email.type === "pattern" &&
                    "Please enter valid Email Address")
                }
              />
            </div>
          </FormFlexWrapper>
          <FormFlexWrapper>
            <div className="child only-child">
              <Password
                label="Password"
                hideLabel={false}
                hideIcon={true}
                placeholder="Password"
                name="password"
                register={register({
                  required: true,
                })}
                error={
                  errors.password &&
                  errors.password.type === "required" &&
                  "Please enter Password"
                }
              />
            </div>
          </FormFlexWrapper>
          <ButtonContainer disabled={buttonText === "Signing In..."}>
            <Button
              variant="newsecondary"
              size="large"
              width="100%"
              type="submit"
            >
              {buttonText}
            </Button>
          </ButtonContainer>
          <ButtonContainer style={{ marginTop: "15px" }}>
            <Button onClick={() => navigateTo()}
              variant="bordered"
              size="large"
              width='100%'>
              Cancel
            </Button>
          </ButtonContainer>
          <FlexWrapper className="justify-between flex-start-on-mobile mt-2">
            <p className="m-0 mb-sm-1">
              Don't have an account?
              <button
                className="anchor-tag"
                type="button"
                onClick={() => navigate("/sign-up/educator")}
              >
                Sign Up
              </button>
            </p>
            <button
              className="anchor-tag p-sm-0"
              type="button"
              onClick={() => navigate("/forgotPassword")}
            >
              Forgot your password?
            </button>
          </FlexWrapper>
        </form>
      </SignInContainer>
    </LoginLayout>
  );
}
